import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Announcement = () => {
  return (
    <section className="bg-gradient-to-br from-amber-50 to-white py-16 border-b border-amber-100 relative overflow-hidden" id="announcement">
      {/* Decorative Background Icon */}
      <div className="absolute -top-10 -right-10 text-amber-500/5 pointer-events-none">
        <SafeIcon name="Info" className="w-96 h-96" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-white rounded-2xl shadow-xl shadow-amber-900/5 border border-amber-200 p-8 md:p-12"
        >
          <div className="flex flex-col md:flex-row gap-6 md:gap-8 items-start">
            
            <div className="flex-shrink-0 bg-amber-100 p-4 rounded-full flex items-center justify-center">
              <SafeIcon name="Info" className="w-8 h-8 text-amber-600" />
            </div>

            <div className="flex-1">
              <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-6 leading-tight">
                S.K. Strassen- und Tiefbau fusioniert mit MK Netzbau GmbH
              </h2>
              
              <div className="space-y-4 text-slate-600 text-lg leading-relaxed">
                <p>
                  Wir möchten Sie darüber informieren, dass die <strong className="text-slate-900">S.K. Strassen- und Tiefbau</strong>, Hauptstraße 2, 35687 Dillenburg mit der <strong className="text-slate-900">MK Netzbau GmbH</strong>, Burger Hauptstraße 14b, 35745 Herborn fusioniert.
                </p>
                <div className="bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r-md my-6 shadow-sm">
                  <p className="font-semibold text-amber-900 m-0">
                    Ab Anfang 2026 erfolgt die gesamte Zusammenarbeit ausschließlich über die MK Netzbau GmbH.
                  </p>
                </div>
                <p>
                  Wir bedanken uns herzlich für das bisherige Vertrauen und die erfolgreiche Zusammenarbeit. Gleichzeitig freuen wir uns sehr, diesen gemeinsamen Weg fortzuführen und auch künftig als MK Netzbau GmbH Ihr zuverlässiger Partner zu sein.
                </p>
                <p className="font-bold text-slate-900 pt-4">
                  Auf eine weiterhin gute und erfolgreiche Zusammenarbeit!
                </p>
              </div>
            </div>

          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Announcement;